import { DealSheetFormValues } from '../ui/rule/types';

class DealSheetConfigurationMapper {
  processSalesCenterFormToAPIDto(formData: DealSheetFormValues): Record<string, any> {
    const charges = formData.charges.map(this.chargeToAPIDto.bind(this));
    const taxes = formData.taxes.map(this.taxToAPIDto.bind(this));

    return {
      charges: [...charges, ...taxes],

      name: formData.name,
      ...(formData.description ? { description: formData.description } : {}),
      dealRules: {
        equipment: {
          type: formData.equipment.type.length ? formData.equipment.type.map(({ value }) => value) : null,
        },
        customer: {
          type: formData.customer.type.length ? formData.customer.type.map(({ value }) => value) : null,
          paymentType: formData.customer.paymentType.length
            ? formData.customer.paymentType.map(({ value }) => value)
            : null,
        },
        location: {
          zip: formData.address.zip ? formData.address.zip : null,
          city: formData.address.city ? formData.address.city : null,
          state: formData.address.state ? formData.address.state : null,
          county: formData.address.county ? formData.address.county : null,
          country: formData.address.country ? formData.address.country : null,
        },
      },
    };
  }

  private chargeToAPIDto(charge: DealSheetFormValues['charges'][number]) {
    return {
      name: charge.name,
      type: charge.type,
      equipmentId: null,
      amount: charge.amount,
      isTaxable: charge.isTaxable,
      amountType: charge.amountType,
      description: charge.description,
    };
  }

  private taxToAPIDto(tax: DealSheetFormValues['taxes'][number]) {
    return {
      name: tax.name,
      type: tax.type,
      equipmentId: null,
      amount: tax.amount,
      isTaxable: tax.isTaxable,
      amountType: tax.amountType,
      description: tax.description,
    };
  }
}

export const dealSheetConfigurationMapper = new DealSheetConfigurationMapper();
